import { EnvService } from '../env.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import * as i0 from "@angular/core";
import * as i1 from "../env.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../objects/Globals";
var AttachmentService = /** @class */ (function () {
    function AttachmentService(env, http, globals) {
        this.env = env;
        this.http = http;
        this.globals = globals;
        this.loginUrl = this.env.servicePath;
    }
    AttachmentService.prototype.uploadAttachment = function (cardId, propId, fileName, data, columnName) {
        if (columnName === void 0) { columnName = ""; }
        var path = this.loginUrl + "UploadFile/" + cardId + "/" + propId + "?filename=" + fileName + "&columnName=" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    AttachmentService.prototype.getAttachmentList = function (cardId, propId, columnName) {
        if (columnName === void 0) { columnName = ""; }
        var path = this.loginUrl + "GetFileList/" + cardId + "/" + propId + "?columnName=" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    AttachmentService.prototype.getMaximumFileUploadSize = function () {
        var path = this.loginUrl + "GetMaximumFileUploadSize";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    AttachmentService.prototype.getAllowedFileTypes = function () {
        var path = this.loginUrl + "GetAllowedFileTypes";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    AttachmentService.prototype.downloadFile = function (attachmentId) {
        var path = this.loginUrl + "DownloadFile/" + attachmentId;
        var httpOptions = {
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    AttachmentService.prototype.downloadAllFile = function (attachmentIds) {
        var path = this.loginUrl + "DownloadAllFile";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, attachmentIds, {
            headers: httpOptions.headers,
            responseType: 'blob' // Explicitly tell Angular to treat the response as a Blob
        });
    };
    AttachmentService.prototype.getFileName = function (attachmentId) {
        var path = this.loginUrl + "GetFileName/" + attachmentId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    AttachmentService.prototype.deleteFile = function (attachmentId, cardId, propertyId, columnName) {
        if (columnName === void 0) { columnName = ""; }
        var path = this.loginUrl + "DeleteFile/" + attachmentId + "/" + cardId + "/" + propertyId + "?columnName=" + columnName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    AttachmentService.prototype.deleteAllFile = function (attachmentIds, cardId, propertyId) {
        var path = this.loginUrl + "DeleteAllFile/" + cardId + "/" + propertyId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, attachmentIds, httpOptions);
    };
    AttachmentService.ngInjectableDef = i0.defineInjectable({ factory: function AttachmentService_Factory() { return new AttachmentService(i0.inject(i1.EnvService), i0.inject(i2.HttpClient), i0.inject(i3.Globals)); }, token: AttachmentService, providedIn: "root" });
    return AttachmentService;
}());
export { AttachmentService };
